// extracted by mini-css-extract-plugin
module.exports = {"record":"record_record_1bXy4","title":"record_title_3K8bw"};